import React, { createContext, useContext, useMemo } from 'react';
var CompareContext = createContext({});
export function CompareContextOverride(_ref) {
  var children = _ref.children,
    groupName = _ref.groupName,
    isSelectable = _ref.isSelectable,
    layout = _ref.layout,
    mergeRecord = _ref.mergeRecord,
    propertyPrefix = _ref.propertyPrefix,
    records = _ref.records;
  var compareContext = useContext(CompareContext);
  var childContext = useMemo(function () {
    var override = {
      groupName: groupName,
      isSelectable: isSelectable,
      layout: layout,
      mergeRecord: mergeRecord,
      propertyPrefix: propertyPrefix,
      records: records
    };
    return Object.assign({}, compareContext, Object.keys(override).reduce(function (acc, key) {
      if (override[key] !== undefined) {
        acc[key] = override[key];
      }
      return acc;
    }, {}));
  }, [compareContext, groupName, isSelectable, layout, mergeRecord, propertyPrefix, records]);
  return /*#__PURE__*/React.createElement(CompareContext.Provider, {
    value: childContext
  }, children);
}
export default CompareContext;